import { Link } from '@/components/Link'
import type { OssPackage } from '@/features/legal/oss-licenses'
import styles from './AboutView.module.css'

const YEAR = new Date().getFullYear()

export interface AboutViewProps {
  packages: OssPackage[] | null
  testId?: string
}

/**
 * Shows the copyright notice and the licenses of the open-source packages in
 * the client bundle.
 */
export function AboutView({ packages, testId }: AboutViewProps) {
  return (
    <main className={styles.root} data-test={testId}>
      <header className={styles.header}>
        <h1 className={styles.title}>About Taxfyle</h1>
        <p className={styles.copyright}>
          Copyright &copy; Tickmark, Inc {YEAR}
        </p>
      </header>
      <hr className={styles.divider} />
      <section className={styles.licenses}>
        <h2 className={styles.headline}>Open-source licenses</h2>
        {packages ? (
          <>
            <p className={styles.description}>
              This app includes the following {packages.length} open-source
              packages.
            </p>
            <ul className={styles.list}>
              {packages.map((pkg) => (
                <li
                  key={`${pkg.name}@${pkg.version}`}
                  className={styles.package}
                  data-test={`${testId}-package-${pkg.name}@${pkg.version}`}
                >
                  <details>
                    <summary className={styles.summary}>
                      <span className={styles.summaryContent}>
                        <span className={styles.name}>{pkg.name}</span>
                        <span className={styles.meta}>
                          {pkg.version} · {pkg.license}
                        </span>
                      </span>
                    </summary>
                    {pkg.repository && /^https?:\/\//.test(pkg.repository) && (
                      <p className={styles.repository}>
                        <Link
                          href={pkg.repository}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {pkg.repository}
                        </Link>
                      </p>
                    )}
                    <pre className={styles.text}>{pkg.text}</pre>
                  </details>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p className={styles.description}>
            The license list is generated by production builds only.
          </p>
        )}
      </section>
    </main>
  )
}
